import { Autocomplete, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { INode, NodeType } from '../../../definitions/Nodes'
import { IAcceptedData } from '../../../definitions/NodesDescription'
import algo from '../../../core/Algo'
import { InfoRounded } from '@mui/icons-material'

interface P {
    acceptedData: IAcceptedData<NodeType>
    selectedNode: INode<NodeType>
    setSelected: (node: INode) => void
    disable: boolean
}

const renderTooltip = (title: string, disable: boolean) => (
    <Tooltip arrow title={title} disableHoverListener={disable}>
        <InfoRounded sx={{ cursor: disable ? undefined : 'pointer', color: disable ? 'var(--icon-disabled)' : 'var(--icon-color)' }} />
    </Tooltip>
)

function NodeSelectEditor({ selectedNode, acceptedData, setSelected, disable }: P) {
    const options = acceptedData?.options ?? []
    const value = selectedNode.data[acceptedData.parameter]

    return (
        <Stack spacing={2}>
            <Stack flexDirection='row' gap={1}>
                {renderTooltip(acceptedData?.tooltipContent, disable)}
                <Typography variant='subtitle2'>{acceptedData?.header ?? null}</Typography>
            </Stack>
            <Autocomplete
                disabled={disable}
                size='small'
                options={options}
                disableClearable
                value={acceptedData?.options?.find(x => x?.value === value) ?? null}
                getOptionLabel={option => option.label}
                onChange={(e, v) => {
                    e.preventDefault()
                    setSelected({ ...selectedNode, data: { ...selectedNode.data, [acceptedData.parameter]: v?.value } })
                }}
                renderInput={params => {
                    return (
                        <TextField
                            {...params}
                            error={acceptedData.isRequired && !algo.hasVal(value)}
                            size='small'
                            fullWidth
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    )
                }}
            />
        </Stack>
    )
}

export default NodeSelectEditor
